export const BLUEBOOK_TOOLBAR_OPTIONS = 'BLUEBOOK_TOOLBAR_OPTIONS';
export const ACKNOWLEDGE_BLUEBOOK_EXAM_MOBILE =
  'ACKNOWLEDGE_BLUEBOOK_EXAM_MOBILE';
